import React, { FC } from 'react';

import styles from './FieldBlock.module.scss';

export interface Props {
  title: string;
  children?: React.ReactNode;
  className?: string;
  error?: string;
}

export const FieldBlock: FC<Props> = (props) => {
  return (
    <div className={props.className}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{props.title}</div>
        {!!props.error && <div className={styles.error}>{props.error}</div>}
      </div>
      <div className={styles.field}>{props.children}</div>
    </div>
  );
};
